// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { electronicChipZoomed16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-electronic-chip-zoomed': IconElectronicChipZoomed;
    }
}

/**
 * The icon component for the 'electronicChipZoomed' icon
 */
export class IconElectronicChipZoomed extends Icon {
    public constructor() {
        super(electronicChipZoomed16X16);
    }
}

registerIcon('icon-electronic-chip-zoomed', IconElectronicChipZoomed);
export const iconElectronicChipZoomedTag = 'nimble-icon-electronic-chip-zoomed';
